import React from 'react';

import IconSeparator from '../../../assets/icons/next-separator.svg';

import styles from './PageTitle.module.css';

export interface PageTitleProps {
  title: string;
  subtitle?: string;
  titleRef?: React.LegacyRef<HTMLDivElement>,
  subtitleRef?: React.LegacyRef<HTMLDivElement>,
  className?: string;
  style?: React.CSSProperties;
}

const PageTitle = (
  {
    title,
    subtitle,
    titleRef,
    subtitleRef,
    className,
    style,
  }: PageTitleProps,
) => {
  const renderSepartor = () => (
    <img
      className={styles.separator}
      src={IconSeparator}
      alt=""
    />
  );

  const renderSubtitle = () => (
    <div ref={subtitleRef} className={styles.subtitle}>
      { subtitle }
    </div>
  );

  const classes = [styles.container];
  if (className) classes.push(className);
  return (
    <div
      className={classes.join(' ')}
      style={style}
    >
      <div ref={titleRef} className={styles.title}>
        { title }
      </div>
      { subtitle ? renderSepartor() : null }
      { subtitle ? renderSubtitle() : null }
    </div>
  );
};

export default PageTitle;
